'use strict';

angular.module('imagetrend.components')
    .directive('hlpHelp', ['Format', function (Format) {
        return {
            restrict: 'AE',
            scope: {
                //attributes
                text: '@',
                classes: '@?'

            },
            replace: true,
            transclude: true,
            templateUrl: 'templates/help/help.html',
            link: function (scope, elem, attrs, ctrl) {
                
            }
        };
    }])

;